<template>
  <div class="ripple-container">
    <SvgIcon name="notice-warning" size="14" class="!fill-warning-500" />
    <div class="ripple"></div>
    <div class="ripple ripple-2"></div>
    <div class="ripple ripple-3"></div>
  </div>
</template>

<script setup>
import SvgIcon from '@/components/svg-icon/SvgIcon.vue'
</script>

<style scoped>
.ripple-container {
  margin-right: 25px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px; /* 22px (icon) + 20px (10px margin on each side) */
  height: 22px;
}

.ripple {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 26px;
  height: 26px;
  border: 2px solid var(--warning-500); /* success-500 color */
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: ripple-animation 3s infinite;
  opacity: 0;
}

.ripple-2 {
  animation-delay: 1s;
}

.ripple-3 {
  animation-delay: 2s;
}

@keyframes ripple-animation {
  0% {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0.9;
  }
  25% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0.7;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.5;
  }
  75% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0.2;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.7);
    opacity: 0;
  }
}

.ripple {
  animation-timing-function: ease-out;
}
</style>
